import { render, staticRenderFns } from "./MixedServices.vue?vue&type=template&id=54bd6f23&"
import script from "./MixedServices.vue?vue&type=script&lang=js&"
export * from "./MixedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports